<template>
  <div :id="allContainerPopoverId" class="brains-all-popover-container" @mouseleave="mouseOut = true" @mouseenter="mouseOut = false">
    <!-- Botones para los diferentes tipos de activadores -->
    <button v-if="activator === 'mouseover' && button" class="brains-filters1-btn brains-popover-container-activator" @click="showPopover = true" @mouseenter="showPopover = true">
      <slot name="popoverName" /> <font-awesome-icon class="brains-filters1-btn-icon" icon="chevron-down" />
    </button>
    <button v-if="activator === 'click' && button" class="brains-filters1-btn brains-popover-container-activator" @click="showPopover = !showPopover">
      <slot name="popoverName" /> <font-awesome-icon class="brains-filters1-btn-icon" icon="chevron-down" />
    </button>
    <div v-if="activator === 'mouseover' && !button" class="brains-popover-container-activator" @click="showPopover = true" @mouseenter="showPopover = true">
      <slot name="popoverName" />
    </div>
    <div v-if="activator === 'click' && !button" class="brains-popover-container-activator" @click="showPopover = !showPopover">
      <slot name="popoverName" />
    </div>
    <!-- Contenido -->
    <div
      :id="popoverId"
      :class="{
        'brains-show-content': showPopover,
        'brains-hide-content': !showPopover,
        'brains-popover-container--left': position === 'left',
        'brains-popover-container--right': position === 'right',
        'brains-popover-container--top': position === 'top',
        'brains-popover-container--bottom-left': position === 'bottom-left',
        'brains-popover-container--border' : border
      }"
      class="brains-popover-container"
      @mouseleave="mouseOut = true"
      @mouseenter="mouseOut = false"
    >
      <!-- :class="{ 'brains-popover-container--left' : position === 'left' }" -->
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopoverBtn',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    activator: {
      type: String,
      default: 'click'
    },
    position: {
      type: String,
      default: 'bottom'
    },
    button: {
      type: Boolean,
      default: true
    },
    border: {
      type: Boolean,
      default: false
    },
    time: {
      type: Number,
      default: 0
    },
    clickOutside: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showPopover: false,
      randomNum: 0,
      mouseOut: true,
      timer: ''
    }
  },
  computed: {
    popoverId() {
      return 'brains-popover-' + this.randomNum
    },
    containerPopoverId() {
      return 'brains-container-popover-' + this.randomNum
    },
    allContainerPopoverId() {
      return 'brains-all-popover-container-' + this.randomNum
    }
  },
  watch: {
    value() {
      this.showPopover = this.value
    },
    showPopover(newOne, oldOne) {
      this.$emit('input', this.showPopover)
      if (newOne) {
        this.assignPositions()
        this.mouseOut = false
      }
    },
    mouseOut(newOne, oldOne) {
      if (newOne && this.time > 0) {
        this.timer = setTimeout(() => {
          this.showPopover = false
        }, this.time * 1000)
      } else {
        clearTimeout(this.timer)
      }
    }
  },
  mounted() {
    var vm = this
    vm.generateRandomNum()

    if (this.activator === 'click') {
      window.addEventListener('click', function(e) {
        var item = document.getElementById(vm.popoverId)
        var notClose = document.getElementsByClassName('not-close-clickable-elements')
        if (item && !item.contains(e.target) && vm.showPopover && !document.getElementById(vm.allContainerPopoverId).contains(e.target) && vm.clickOutside && !vm.checkContain(e.target, notClose)) {
          vm.showPopover = false
        }
      })
    } else {
      window.addEventListener('mouseover', function(e) {
        var item = document.getElementById(vm.popoverId)
        var item2 = document.getElementById(vm.allContainerPopoverId)
        var notClose = document.getElementsByClassName('not-close-clickable-elements')
        if (item && !item.contains(e.target) && !item2.contains(e.target) && vm.showPopover && vm.clickOutside && !vm.checkContain(e.target, notClose)) {
          vm.showPopover = false
        }
      })
    }
    setTimeout(() => {
      vm.assignPositions()
    }, 200)
  },
  methods: {
    /**
     * Función para comprobar si un elemento clicado es alguno de los excluidos por la clase not-close-clickable-elements
     * Usado principalmente para evitar que se cierre el popover cuando tenemos clics en algunos elementos de la pagina que
     * no queremos que lo cierren
     */
    checkContain(parent, items) {
      var res = false
      if (items !== undefined && items !== null) {
        [...items].forEach(item => {
          if (parent === item) {
            res = true
          }
        })
      }
      return res
    },
    generateRandomNum() {
      this.randomNum = Math.floor(Math.random() * (9999 - 0)) + 0
    },
    assignPositions() {
      var containerData = document.getElementById(this.popoverId)
      var item = document.getElementById(this.allContainerPopoverId)

      containerData = document.getElementById(this.popoverId)

      if (containerData === null || containerData === undefined) return

      var width = item.getBoundingClientRect().width
      // var height = item.getBoundingClientRect().height

      switch (this.position) {
        case 'bottom-left':
          containerData.style.right = width + 'px'
          break
        case 'left':
          // SE CAMBIA SOLO PARA EL LEFT PORQUE FALLABA EN ALGUNOS CONTENEDORES
          containerData.style.right = width + 'px'
          containerData.style.top = '-' + (containerData.getBoundingClientRect().height / 2.4) + 'px'
          // containerData.style.top = item.offsetTop + 'px'
          // containerData.style.left = (item.offsetLeft - containerData.getBoundingClientRect().width - 5) + 'px'
          break
        case 'right':
          containerData.style.left = width + 'px'
          containerData.style.top = '-' + (containerData.getBoundingClientRect().height / 2.4) + 'px'
          break
        case 'top':
          containerData.style.bottom = width + 8 + 'px'
          break
        default:
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.brains-all-popover-container {
  display: inline-block;
  position: relative;
}
.brains-popover-container {
  background-color: white;

  &--right {
    top: 0;
  }

  &--border {
    border: 1px solid rgb(221, 221, 221);
  }
}
</style>
